import { MAX_AGE_FOR_PSQ, MIN_AGE_FOR_PSQ } from 'constants/profile'
import { FieldValidator } from 'formik'
import React from 'react'
import { TFunction } from 'react-i18next'
import styles from './psq.module.scss'

type QAType = 'radio' | 'input' | 'select'

export type RmgQA = QA<'radio'> | QA<'input'>

interface BaseQA<T> {
  type: T
  questionId: string
  questionTransKey: string
  introTextTransKey?: string
  defaultValue?: any
  validator?: (t: TFunction) => FieldValidator
}

type QA<T extends QAType> = T extends 'radio'
  ? BaseQA<T> & RadioQA
  : T extends 'input'
  ? BaseQA<T> & InputQA
  : never

interface RadioQA {
  opts: string[]
  buttonsLayout?: boolean
}

interface InputQA {
  reviewTextTransKey: string
  inputProps: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
}

export const psqFormData: RmgQA[] = [
  {
    type: 'radio',
    questionId: '1',
    questionTransKey: 'q1.question',
    introTextTransKey: 'q1.intro',
    opts: ['q1a1', 'q1a2', 'q1a3', 'q1a4', 'q1a5'],
  },
  {
    type: 'radio',
    questionId: '2',
    questionTransKey: 'q2.question',
    introTextTransKey: 'q2.intro',
    opts: ['q2a1', 'q2a2', 'q2a3', 'q2a4', 'q2a5', 'q2a6', 'q2a7', 'q2a8'],
  },
  {
    type: 'radio',
    questionId: '3',
    questionTransKey: 'q3.question',
    opts: ['q3a1', 'q3a2'],
    buttonsLayout: true,
  },
  {
    type: 'radio',
    questionId: '4',
    questionTransKey: 'q4.question',
    opts: ['q4a1', 'q4a2', 'q4a3', 'q4a4'],
  },
  {
    type: 'radio',
    questionId: '5',
    questionTransKey: 'q5.question',
    opts: ['q5a1', 'q5a2', 'q5a3', 'q5a4', 'q5a5', 'q5a6'],
  },
]

export const publicPsqFormData: RmgQA[] = [
  {
    type: 'radio',
    questionId: '1',
    questionTransKey: 'q1.question',
    introTextTransKey: 'q1.intro',
    opts: ['q1a1', 'q1a2', 'q1a3', 'q1a4', 'q1a5'],
  },
  {
    type: 'radio',
    questionId: '2',
    questionTransKey: 'q2.question',
    introTextTransKey: 'q2.intro',
    opts: ['q2a1', 'q2a2', 'q2a3', 'q2a4', 'q2a5', 'q2a6', 'q2a7', 'q2a8'],
  },
  {
    type: 'radio',
    questionId: '3',
    questionTransKey: 'q3.question',
    opts: ['q3a1', 'q3a2'],
    buttonsLayout: true,
  },
  {
    type: 'radio',
    questionId: '4',
    questionTransKey: 'q4.question',
    opts: ['q4a1', 'q4a2', 'q4a3', 'q4a4'],
  },
  {
    type: 'radio',
    questionId: '5',
    questionTransKey: 'q5.question',
    opts: ['q5a1', 'q5a2', 'q5a3', 'q5a4', 'q5a5', 'q5a6'],
  },
  {
    type: 'radio',
    questionId: '6',
    questionTransKey: 'q6.question',
    opts: ['q6a1', 'q6a2'],
  },
  {
    type: 'input',
    inputProps: {
      type: 'number',
      step: 1,
      className: styles.ageInput,
    },
    defaultValue: 0,
    questionId: '7',
    questionTransKey: 'q7.question',
    reviewTextTransKey: 'q7a1',
    validator: (t: TFunction) => value => {
      if (isNaN(value))
        return t('form.validationErrors.invalidValue', { ns: 'strCommonUI' }) as string
      const age = parseFloat(value)
      const isInteger = (age | 0) === age

      if (!isInteger)
        return t('form.validationErrors.invalidValue', { ns: 'strCommonUI' }) as string

      if (age < MIN_AGE_FOR_PSQ)
        return t('form.validationErrors.minAge', {
          ns: 'strCommonUI',
          minAge: MIN_AGE_FOR_PSQ,
        }) as string

      if (age > MAX_AGE_FOR_PSQ)
        return t('form.validationErrors.maxAge', {
          ns: 'strCommonUI',
          maxAge: MAX_AGE_FOR_PSQ,
        }) as string

      return undefined
    },
  },
]
